import React from 'react'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import VerifiedIcon from '@mui/icons-material/Verified'
import {useI18n} from 'store/Store.js'

const VerifiedChip = () => {
    const {i18n} = useI18n()

    return (
        <Stack direction="row" spacing={1}>
            <Chip
                color="primary"
                icon={<VerifiedIcon fontSize="10px" />}
                label={i18n.t('toolbar.linkedChoreographer')}
                sx={{
                    width: 58,
                    height: 12,
                    position: 'absolute',
                    right: 8,
                    bottom: 10,
                    fontSize: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: '12px',
                }}
            />
        </Stack>
    )
}

export default VerifiedChip
